import { useMutation, useQueryClient } from "react-query";
import { useSnackbar } from "notistack";

import { WorkOrderState } from "../../models";
import { RQ } from "../../globals/enums";
import { add } from "../../api/generic-api";

export const useAddWorkOrderState = () => {
  const queryClient = useQueryClient();
  const { enqueueSnackbar } = useSnackbar();

  return useMutation(
    (workOrderState: Omit<WorkOrderState, "id">) =>
      add<WorkOrderState>("work-order-states", workOrderState),
    {
      onSuccess: (workOrderState) => {
        enqueueSnackbar("Work Order State Added", { variant: "success" });
        queryClient.setQueryData<WorkOrderState[]>(
          RQ.WORK_ORDER_STATES,
          (workOrderStates: WorkOrderState[] | undefined) => {
            return [...(workOrderStates ?? []), workOrderState];
          }
        );
      },
      onError: () => {
        enqueueSnackbar("Work Order State Adding Error", { variant: "error" });
      },
    }
  );
};
